export const HIGHLIGHTED_DELAY = 2 * 60 * 1000;
